'use client';

import { useReportWebVitals } from 'next/web-vitals';

interface WebVitalsProps {}

export const WebVitals: React.FC<WebVitalsProps> = () => {
  useReportWebVitals(metric => {
    switch (metric.name) {
      case 'FCP': {
        // handle FCP results
      }
      case 'LCP': {
        // handle LCP results
      }
      // ...
    }
    // console.log(metric)
  });
  return null;
};
